<div class="menu-root flex flex-column" *ngIf="items">
  <p-panelMenu
    id="menu"
    [style]="{ width: '100%', 'padding-top': '35px' }"
    [model]="items"
    (click)="highlight()"
    [ngClass]="smaller_font ? 'smaller-font' : null"
    multiple="true"
  >
  </p-panelMenu>
  <div class="menu-footer flex flex-column pl-5 pr-2">
    <ng-container *ngIf="user_role !== 'CC'">
      <div>
        <h3 class="mb-0 font_help_header">{{ 'MENU.NEED_HELP' | translate }}</h3>
        <p class="m-0 font_help_body">
          <span (click)="contactEmail.toggle($event)">{{ 'MENU.CONTACT' | translate }}</span> {{ 'MENU.YOUR_PROGRAM_MANAGER' | translate }}
          {{ 'MENU.OR' | translate }} <span (click)="reportEmail.toggle($event)">{{ 'MENU.REPORT' | translate }}</span>
          {{ 'MENU.YOUR_TECHNICAL_ISSUES' | translate }}.
        </p>
        <p-popover #contactEmail [dismissable]="true" [style]="{ 'margin-top': '10px' }">
          <div>mentoring&#64;femmepalette.com</div>
        </p-popover>
        <p-popover #reportEmail [dismissable]="true" [style]="{ 'margin-top': '10px' }">
          <div>help&#64;femmepalette.com</div>
        </p-popover>
      </div>
      <div class="pt-3 line-height-2">
        <ng-container *ngIf="user_role === 'ME' || user_role === 'CH'">
          <a href="https://www.femmepalette.com/refund" target="_blank" class="underline text-xs">{{ 'MENU.TERMS' | translate }}</a
          >, <a href="https://www.femmepalette.com/gdpr" target="_blank" class="underline text-xs">{{ 'MENU.PRIVACY' | translate }}</a
          >,
          <a [href]="TERMS" target="_blank" class="underline text-xs">{{ 'MENU.PLATFORM_TERMS' | translate }}</a>
        </ng-container>
        <ng-container *ngIf="user_role === 'MR'">
          <a href="https://www.femmepalette.com/refund" target="_blank" class="underline text-xs">{{ 'MENU.TERMS' | translate }}</a
          >, <a href="https://www.femmepalette.com/gdpr" target="_blank" class="underline text-xs">{{ 'MENU.PRIVACY' | translate }}</a
          >, <a [href]="TERMS" target="_blank" class="underline text-xs">{{ 'MENU.PLATFORM_TERMS' | translate }}</a
          >,
          <br />
          <a href="https://www.femmepalette.com/mentor-agreement" target="_blank" class="underline text-xs">
            {{ 'MENU.MENTOR_AGREEMENT' | translate }}</a
          >
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="user_role === 'CC'">
      <div>
        <h3 class="mb-0 font_help_header">{{ 'MENU.NEED_HELP' | translate }}</h3>
        <p class="m-0 font_help_body">
          <span (click)="contactEmail.toggle($event)">{{ 'MENU.CONTACT' | translate }}</span> {{ 'MENU.YOUR_ACCOUNT_MANAGER' | translate }}
          {{ 'MENU.OR' | translate }} <span (click)="reportEmail.toggle($event)">{{ 'MENU.REPORT' | translate }}</span>
          {{ 'MENU.YOUR_TECHNICAL_ISSUES' | translate }}.
        </p>
        <p-popover #contactEmail [dismissable]="true" [style]="{ 'margin-top': '10px' }">
          <div>lucia.z&#64;femmepalette.com</div>
        </p-popover>
        <p-popover #reportEmail [dismissable]="true" [style]="{ 'margin-top': '10px' }">
          <div>help&#64;femmepalette.com</div>
        </p-popover>
      </div>
      <div class="pt-3">
        <a href="https://www.femmepalette.com/gdpr" target="_blank" class="underline text-xs">{{ 'MENU.PRIVACY' | translate }}</a
        >,
        <a [href]="TERMS" target="_blank" class="underline text-xs">{{ 'MENU.PLATFORM_TERMS' | translate }}</a>
      </div>
    </ng-container>
  </div>
</div>
